import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import Link from "react-router-dom/Link";
import { validatePassword } from "../../../services/validation";

import { changePasswordAction } from "../../../redux/actions/auth.actions";
import InputField from "../InputField";

export class ChangePasswordForm extends React.Component {
  handleChangePassword = values => {
    this.props.changePasswordAction(values);
  };

  render() {
    const { handleSubmit } = this.props;
    return (
      <div className="col-lg-4 text-center form-margin-container">
        <h3 id="sign-in-brand">Change Password</h3>
        <br />
        <div className="row align-items-center justify-content-center">
          <div className="col-lg-6 text-center">
            <form onSubmit={handleSubmit(this.handleChangePassword)}>
              <Field
                label="Current Password"
                hideLabel={true}
                name="oldPassword"
                type="password"
                id="old-password-input"
                placeholder="Old Password"
                textAlign="center"
                component={InputField}
              />
              <br />
              <Field
                label="New Password"
                hideLabel={true}
                name="newPassword"
                type="password"
                id="new-password-input"
                placeholder="New Password"
                textAlign="center"
                component={InputField}
              />
              <br />
              <Field
                label="Confirm New Password"
                hideLabel={true}
                name="confirmNewPassword"
                type="password"
                id="confirm-new-password-input"
                placeholder="Confirm New Password"
                textAlign="center"
                component={InputField}
              />
              <br />
              <button
                type="submit"
                id="login-btn"
                disabled={!this.props.valid}
                className="btn btn-primary btn-block"
              >
                Save
              </button>
              <br />
              <Link to="/" className="btn btn-primary btn-block">
                Cancel
              </Link>
            </form>
          </div>
        </div>
        {/*<br />*/}
        {/*<ul className="list-group">*/}
        {/*{renderErrorsList(this.props.registration.errors)}*/}
        {/*</ul>*/}
      </div>
    );
  }
}

function validate(values) {
  const errors = {};

  const passwordErrors = validatePassword(values.newPassword, "newPassword");

  if (!values.oldPassword) {
    errors.oldPassword = "Enter your old password";
  }

  if (values.newPassword !== values.confirmNewPassword) {
    errors.confirmNewPassword = "Passwords do not match";
  }

  return { ...errors, ...passwordErrors };
}

export default reduxForm({
  validate,
  form: "ChangePasswordForm"
})(
  connect(
    null,
    { changePasswordAction }
  )(ChangePasswordForm)
);



// WEBPACK FOOTER //
// ./src/components/forms/ChangePasswordForm/ChangePasswordForm.jsx